import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

import { AuthService } from 'src/app/shared/services/auth.service';

/**
 * AVD-only auth guard.
 *
 * Dedicated guard for the standalone /avd view - does NOT reuse the dashboard
 * AuthGuard. Respects the MSAL auth flow: the AVD session is a Firebase session
 * minted from the MSAL id token, and the feed discovery needs a live MSAL account
 * to acquire the access token. So it requires BOTH a Firebase session and an MSAL
 * account; otherwise it sends the user back to login.
 */
@Injectable({ providedIn: 'root' })
export class AvdAuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private msalService: MsalService,
    private router: Router
  ) {}

  /** AVD users always return to the AVD login route. */
  private readonly loginRoute = '/login/avd';

  canActivate(): boolean | UrlTree {
    if (!this.authService.isLoggedIn) {
      return this.router.createUrlTree([this.loginRoute]);
    }

    const hasMsalAccount =
      this.msalService.instance.getAllAccounts().length > 0;

    if (!hasMsalAccount) {
      return this.router.createUrlTree([this.loginRoute]);
    }

    return true;
  }
}
